// KirchHero i18n translations — DE / EN / ES
// (PoD & Gelato bewusst raus — Anbieter-neutral formuliert)

export const translations = {
  de: {
    nav: {
      shop: "Shop",
      story: "Story",
      newsletter: "Newsletter",
      contact: "Kontakt",
    },
    hero: {
      eyebrow: "Royal Streetwear · Limited Drops",
      chapter: "CH.00 — Prelude",
      titleLine1: "Trag deine",
      titleLine2: "Krone.",
      subtitle:
        "KirchHero ist die Streetwear-Linie für die Helden des Alltags. Schwarz. Gold. Burgund. Kompromisslos.",
      ctaShop: "Kollektion entdecken",
      ctaStory: "Unsere Story",
    },
    marquee: [
      "King Kirchner",
      "Royal Streetwear",
      "Limited Drops",
      "Made for Heroes",
      "Black · Gold · Burgundy",
    ],
    products: {
      chapter: "CH.01 — The Drop",
      eyebrow: "Drops",
      title: "Die aktuelle Kollektion",
      subtitle:
        "T-Shirts, Hoodies und Caps in streng limitierten Drops. Weltweit versandbereit.",
      buy: "Im Shop ansehen",
      view: "Ansehen",
      addShort: "Hinzu",
      choose: "Wählen",
      soldOut: "Ausverkauft",
      loading: "Lade Produkte …",
      empty:
        "Aktuell sind keine Produkte verfügbar. Trag dich in den Newsletter ein, um beim nächsten Drop dabei zu sein.",
      categoryEmpty: "Keine Produkte in dieser Kategorie.",
      showAll: "Alle Produkte zeigen",
      from: "ab",
    },
    pdp: {
      back: "Zurück",
      backShop: "Zur Kollektion",
      description: "Beschreibung",
      addToCart: "In den Warenkorb",
      addedToCart: "Zum Warenkorb hinzugefügt",
      selectVariant: "Bitte zuerst eine Variante wählen.",
      inStock: "Auf Lager — sofort lieferbar",
      taxIncluded: "inkl. MwSt.",
      feature1: "Print-on-Demand · Produktion in der EU",
      feature2: "Weltweiter Versand · 2–5 Werktage Bearbeitung",
      feature3: "Sichere Zahlung · 14 Tage Widerrufsrecht",
      notFoundTitle: "Produkt nicht gefunden",
      notFoundBody: "Dieses Stück ist vermutlich nicht mehr Teil der aktuellen Kollektion.",
    },
    cart: {
      eyebrow: "Crown Cart",
      title: "Warenkorb",
      close: "Schließen",
      emptyTitle: "Noch leer",
      emptyBody: "Entdecke die aktuelle Kollektion und füge dein erstes Stück hinzu.",
      continue: "Weiter shoppen",
      remove: "Entfernen",
      subtotal: "Zwischensumme",
      shippingNote: "Versand und Steuern werden im Checkout berechnet.",
      checkout: "Zur Kasse",
    },
    about: {
      chapter: "CH.02 — Origin",
      eyebrow: "Brand Story",
      title: "Vom Namen Kirchner — zum König.",
      paragraph1:
        "KirchHero ist mehr als eine Marke. Sie ist eine Haltung. Geboren aus dem Familiennamen Kirchner und der Idee, dass jeder Mensch ein Held seiner eigenen Geschichte ist.",
      paragraph2:
        "Jedes Stück ist Statement: schwarze Stoffe, goldene Akzente, burgunder Tiefe, kupferne Wärme. Limitierte Drops, kompromisslose Qualität — nur das, was du wirklich willst.",
      stat1Label: "Limited Drops",
      stat1Value: "12+",
      stat2Label: "Weltweiter Versand",
      stat2Value: "30+ Länder",
      stat3Label: "Kompromiss",
      stat3Value: "0%",
    },
    newsletter: {
      chapter: "CH.03 — The Court",
      eyebrow: "Bleib im Loop",
      title: "Erste Reihe beim nächsten Drop.",
      subtitle:
        "Erhalte 15% auf deine erste Bestellung und sei der Erste, der neue Drops sieht.",
      placeholder: "Deine E-Mail",
      submit: "Beitreten",
      success: "Willkommen in der Crown Club. Check deine Inbox.",
      error: "Etwas ist schiefgelaufen. Versuch es nochmal.",
      invalid: "Bitte gib eine gültige E-Mail-Adresse ein.",
      rewardLabel: "Dein Anpfiff-Bonus",
      rewardIntro: "Dein persönlicher {p}%-Rabattcode für die erste Bestellung — gleich im Checkout einlösbar.",
      codeLabel: "Rabattcode",
      copy: "Kopieren",
      copied: "Kopiert",
      codeCopied: "Code in die Zwischenablage kopiert.",
      codeCopyFail: "Code konnte nicht kopiert werden.",
      rewardHint: "Code einlösbar im Checkout. Eine Verwendung pro Kunde. Nicht mit anderen Aktionen kombinierbar.",
    },
    footer: {
      tagline: "Trag deine Krone.",
      blurb:
        "Royal Streetwear für die Helden des Alltags. Limitierte Drops, weltweit versandbereit.",
      shopLinks: "Shop",
      info: "Info",
      legal: "Rechtliches",
      imprint: "Impressum",
      privacy: "Datenschutz",
      terms: "AGB",
      copyright: "Alle Rechte vorbehalten.",
    },
  },
  en: {
    nav: {
      shop: "Shop",
      story: "Story",
      newsletter: "Newsletter",
      contact: "Contact",
    },
    hero: {
      eyebrow: "Royal Streetwear · Limited Drops",
      chapter: "CH.00 — Prelude",
      titleLine1: "Wear your",
      titleLine2: "Crown.",
      subtitle:
        "KirchHero is the streetwear line for everyday heroes. Black. Gold. Burgundy. Uncompromising.",
      ctaShop: "Shop the Drop",
      ctaStory: "Our Story",
    },
    marquee: [
      "King Kirchner",
      "Royal Streetwear",
      "Limited Drops",
      "Made for Heroes",
      "Black · Gold · Burgundy",
    ],
    products: {
      chapter: "CH.01 — The Drop",
      eyebrow: "Drops",
      title: "Current Collection",
      subtitle:
        "T-Shirts, hoodies and caps in strictly limited drops. Shipped worldwide.",
      buy: "View in Store",
      view: "View",
      addShort: "Add",
      choose: "Choose",
      soldOut: "Sold out",
      loading: "Loading products …",
      empty:
        "No products available yet. Join the newsletter to be first on the next drop.",
      categoryEmpty: "No products in this category.",
      showAll: "Show all products",
      from: "from",
    },
    pdp: {
      back: "Back",
      backShop: "Back to collection",
      description: "Description",
      addToCart: "Add to Cart",
      addedToCart: "Added to cart",
      selectVariant: "Please choose a variant first.",
      inStock: "In stock — ready to ship",
      taxIncluded: "tax incl.",
      feature1: "Print on demand · Produced in the EU",
      feature2: "Worldwide shipping · 2–5 business days processing",
      feature3: "Secure payment · 14-day right of withdrawal",
      notFoundTitle: "Product not found",
      notFoundBody: "This piece is likely no longer part of the current collection.",
    },
    cart: {
      eyebrow: "Crown Cart",
      title: "Cart",
      close: "Close",
      emptyTitle: "Still empty",
      emptyBody: "Explore the current collection and add your first piece.",
      continue: "Continue shopping",
      remove: "Remove",
      subtotal: "Subtotal",
      shippingNote: "Shipping and taxes are calculated at checkout.",
      checkout: "Checkout",
    },
    about: {
      chapter: "CH.02 — Origin",
      eyebrow: "Brand Story",
      title: "From the name Kirchner — to king.",
      paragraph1:
        "KirchHero is more than a brand. It's an attitude. Born from the family name Kirchner and the idea that every person is the hero of their own story.",
      paragraph2:
        "Every piece is a statement: black fabrics, gold accents, burgundy depth, copper warmth. Limited drops, uncompromising quality — only what you truly want.",
      stat1Label: "Limited Drops",
      stat1Value: "12+",
      stat2Label: "Worldwide Shipping",
      stat2Value: "30+ Countries",
      stat3Label: "Compromise",
      stat3Value: "0%",
    },
    newsletter: {
      chapter: "CH.03 — The Court",
      eyebrow: "Stay in the loop",
      title: "Front row on the next drop.",
      subtitle:
        "Get 15% off your first order and be the first to see new drops.",
      placeholder: "Your email",
      submit: "Join",
      success: "Welcome to the Crown Club. Check your inbox.",
      error: "Something went wrong. Try again.",
      invalid: "Please enter a valid email address.",
      rewardLabel: "Your Kickoff Bonus",
      rewardIntro: "Your personal {p}% discount code for your first order — redeemable right at checkout.",
      codeLabel: "Discount code",
      copy: "Copy",
      copied: "Copied",
      codeCopied: "Code copied to clipboard.",
      codeCopyFail: "Couldn't copy code.",
      rewardHint: "Redeemable at checkout. One use per customer. Not combinable with other offers.",
    },
    footer: {
      tagline: "Wear your crown.",
      blurb:
        "Royal streetwear for everyday heroes. Limited drops, shipped worldwide.",
      shopLinks: "Shop",
      info: "Info",
      legal: "Legal",
      imprint: "Imprint",
      privacy: "Privacy",
      terms: "Terms",
      copyright: "All rights reserved.",
    },
  },
  es: {
    nav: {
      shop: "Tienda",
      story: "Historia",
      newsletter: "Newsletter",
      contact: "Contacto",
    },
    hero: {
      eyebrow: "Royal Streetwear · Limited Drops",
      chapter: "CH.00 — Preludio",
      titleLine1: "Lleva tu",
      titleLine2: "Corona.",
      subtitle:
        "KirchHero es la línea streetwear para los héroes de cada día. Negro. Oro. Burdeos. Sin concesiones.",
      ctaShop: "Ver colección",
      ctaStory: "Nuestra historia",
    },
    marquee: [
      "King Kirchner",
      "Royal Streetwear",
      "Limited Drops",
      "Hecho para héroes",
      "Negro · Oro · Burdeos",
    ],
    products: {
      chapter: "CH.01 — El Drop",
      eyebrow: "Drops",
      title: "Colección actual",
      subtitle:
        "Camisetas, sudaderas y gorras en drops estrictamente limitados. Envíos a todo el mundo.",
      buy: "Ver en tienda",
      view: "Ver",
      addShort: "Añadir",
      choose: "Elegir",
      soldOut: "Agotado",
      loading: "Cargando productos …",
      empty:
        "Aún no hay productos disponibles. Únete al newsletter para no perderte el próximo drop.",
      categoryEmpty: "No hay productos en esta categoría.",
      showAll: "Mostrar todos los productos",
      from: "desde",
    },
    pdp: {
      back: "Volver",
      backShop: "A la colección",
      description: "Descripción",
      addToCart: "Añadir al carrito",
      addedToCart: "Añadido al carrito",
      selectVariant: "Por favor elige primero una variante.",
      inStock: "En stock — envío inmediato",
      taxIncluded: "IVA incl.",
      feature1: "Print-on-Demand · Producción en la UE",
      feature2: "Envío mundial · 2–5 días laborables de procesamiento",
      feature3: "Pago seguro · 14 días de derecho de desistimiento",
      notFoundTitle: "Producto no encontrado",
      notFoundBody: "Esta pieza probablemente ya no forma parte de la colección actual.",
    },
    cart: {
      eyebrow: "Crown Cart",
      title: "Carrito",
      close: "Cerrar",
      emptyTitle: "Aún vacío",
      emptyBody: "Explora la colección actual y añade tu primera pieza.",
      continue: "Seguir comprando",
      remove: "Quitar",
      subtotal: "Subtotal",
      shippingNote: "El envío y los impuestos se calculan en el checkout.",
      checkout: "Finalizar compra",
    },
    about: {
      chapter: "CH.02 — Origen",
      eyebrow: "Historia de la marca",
      title: "Del apellido Kirchner — al rey.",
      paragraph1:
        "KirchHero es más que una marca. Es una actitud. Nacida del apellido Kirchner y la idea de que cada persona es el héroe de su propia historia.",
      paragraph2:
        "Cada prenda es una declaración: telas negras, acentos dorados, profundidad burdeos, calidez del cobre. Drops limitados, calidad sin concesiones — solo lo que de verdad quieres.",
      stat1Label: "Drops limitados",
      stat1Value: "12+",
      stat2Label: "Envío mundial",
      stat2Value: "30+ países",
      stat3Label: "Concesión",
      stat3Value: "0%",
    },
    newsletter: {
      chapter: "CH.03 — La Corte",
      eyebrow: "Mantente al día",
      title: "Primera fila en el próximo drop.",
      subtitle:
        "Obtén 15% de descuento en tu primer pedido y sé el primero en ver nuevos drops.",
      placeholder: "Tu email",
      submit: "Unirse",
      success: "Bienvenido al Crown Club. Revisa tu bandeja de entrada.",
      error: "Algo salió mal. Inténtalo de nuevo.",
      invalid: "Por favor, introduce un email válido.",
      rewardLabel: "Tu Bono de Apertura",
      rewardIntro: "Tu código de descuento personal del {p}% para tu primer pedido — canjeable en el checkout.",
      codeLabel: "Código de descuento",
      copy: "Copiar",
      copied: "Copiado",
      codeCopied: "Código copiado al portapapeles.",
      codeCopyFail: "No se pudo copiar el código.",
      rewardHint: "Canjeable en el checkout. Un uso por cliente. No combinable con otras ofertas.",
    },
    footer: {
      tagline: "Lleva tu corona.",
      blurb:
        "Royal streetwear para los héroes de cada día. Drops limitados, envíos a todo el mundo.",
      shopLinks: "Tienda",
      info: "Info",
      legal: "Legal",
      imprint: "Aviso legal",
      privacy: "Privacidad",
      terms: "Términos",
      copyright: "Todos los derechos reservados.",
    },
  },
};

export const LANGUAGES = [
  { code: "de", label: "DE" },
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
];
